import { useCallback, useEffect, useState } from 'react';
import { store } from '../redux/index';
import * as actions from '../redux/slices/status';
export const useContentManagement = () => {
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        const state = store.getState();
        setIsEditing(state.status.isEditing);
        const unsubscribe = store.subscribe(() => {
            const state = store.getState();
            setIsEditing(state.status.isEditing);
        });
        return () => {
            unsubscribe();
        };
    }, []);
    const toggleIsEditing = useCallback(() => {
        store.dispatch(actions.setIsEditing(!isEditing));
    }, [isEditing]);
    return {
        isPublishing: true,
        isEditing,
        toggleIsEditing
    };
};
